import React from 'react';
import styled from 'astroturf/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';

type Action = {
  href: string;
  name: string;
};

type Props = {
  email: string;
  user: User;
};

type User = {
  banned?: boolean;
  // Whether there is an existing request to unflag this user
  requested_unflag?: boolean;
};

const ActionText = styled.a`
  color: #fff;
  cursor: pointer;
  text-decoration: underline;

  &:not(:last-of-type) {
    margin-right: 10px;
  }

  &:hover {
    color: #fff;
  }
`;

const Banner = styled.div`
  align-items: center;
  background: #f0ad4e;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  min-height: 40px;
  padding: 10px;
  justify-content: center;
`;

const Message = styled.p`
  margin: 0 10px;
`;

const getMessageAndActions = (
  email: string,
  user: User,
): [string, Action[]] => {
  let actions: Action[] = [];
  let message: string;

  if (user.banned) {
    actions = [
      {
        href: '/user_unflag_requests/new',
        name: 'Request Unflagging',
      },
    ];
    message =
      'Your account was flagged as suspicious by an automated system. If this was an error, please accept our apologies.';
    if (user.requested_unflag) {
      message =
        "Your account was flagged as suspicious, and your reconsideration request is awaiting manual review. We're sorry for any inconvenience.";
    }
  } else {
    actions = [
      {
        // TODO: Use routes here
        href: '/confirm/send_new_email',
        name: 'Resend',
      },
      {
        // TODO: Use routes here
        href: '/confirm/sent#email',
        name: 'Change Email',
      },
    ];
    message = `Please confirm your account. We've sent a confirmation link to ${email}`;
  }

  return [message, actions];
};

const ConfirmationBanner: React.FC<Props> = ({ email, user }) => {
  if (!user) return null;

  const [message, actions] = getMessageAndActions(email, user);

  return (
    <Banner>
      <FontAwesomeIcon icon={faExclamationTriangle} />
      <Message>{message}</Message>
      {actions.map((action) => (
        <ActionText href={action.href} key={action.name}>
          {action.name}
        </ActionText>
      ))}
    </Banner>
  );
};

export default ConfirmationBanner;
